<crm-single-select
  dataKey="name"
  [options]="priorities"
  [(selectedItem)]="selectedPriority"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  (selectedItemChange)="selectedPriorityChange.emit($event)"
  [isTemplateCombined]="true"
  [filter]="false"
  [showClear]="showClear"
  [disabled]="disabled"
  [appendTo]="appendTo"
  filterBy="name">
  <ng-template
    #itemTemplate
    let-priority="item">
    {{ priority?.value | helpdeskTaskPriorityName }}
  </ng-template>
</crm-single-select>
